(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3640],{

/***/ 13932:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-trial",
      function () {
        return __webpack_require__(46743);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 46743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ FreeTrial; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 12 modules
var i18 = __webpack_require__(36971);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/props-resolver.js
var props_resolver = __webpack_require__(77915);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/ProductsTab/index.js
var ProductsTab = __webpack_require__(7789);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/index.js + 1 modules
var Panel = __webpack_require__(13398);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/ContentContainer/index.js
var ContentContainer = __webpack_require__(12985);
// EXTERNAL MODULE: ./src/routes.js
var routes = __webpack_require__(30233);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Spinner/index.js + 1 modules
var Spinner = __webpack_require__(39116);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/SmartForm/index.js + 8 modules
var SmartForm = __webpack_require__(3816);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/Html/index.js
var Html = __webpack_require__(73972);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/anyCaptcha/index.js + 7 modules
var anyCaptcha = __webpack_require__(58135);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/either/index.js + 1 modules
var either = __webpack_require__(71970);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/GqlError.js
var GqlError = __webpack_require__(86870);
// EXTERNAL MODULE: ./src/nav-utils.js
var nav_utils = __webpack_require__(33347);
// EXTERNAL MODULE: ./src/routing-utils.js + 2 modules
var routing_utils = __webpack_require__(92267);
;// CONCATENATED MODULE: ./src/FreeTrialForm/action.js





const expectedErrors = (0,GqlError/* mapGqlError */.L4)({
    401: "errors.TOKEN_EXPIRED",
    404: "errors.TOKEN_NOT_FOUND"
});
const navToPathWithSettledTokens = (param, storageService)=>{
    let { token , refreshToken , trialId  } = param;
    storageService.token.write(token);
    storageService.refreshToken.write(refreshToken);
    (0,routing_utils/* toCompleteProfilePage */.oL)(trialId);
};
const navToCompleteProfilePage = (requestTrial, storageService)=>requestTrial.token && requestTrial.refreshToken ? navToPathWithSettledTokens(requestTrial, storageService) : (0,routing_utils/* toCompleteProfilePage */.oL)(requestTrial.trialId);
const handleSuccess = (requestTrial, storageService)=>!requestTrial.isAuthorized ? (0,nav_utils/* navToPath */.SS)(routes/* default.confirmEmail */.Z.confirmEmail) : navToCompleteProfilePage(requestTrial, storageService);
/**
 * Sets email for trial license and redirects to confirm email or complete profile if succeeded
 *
 * @type {
		(form: { email: string; }, turingToken: string, turingType: string) =>
			(container: { trialService: any; storageService: any; }) =>
				Promise<import("../utils-shared/either").Either<string, void>>
	} */ const requestFreeTrial = (param, turingToken, turingType)=>{
    let { email  } = param;
    return (param)=>{
        let { trialService , storageService  } = param;
        return trialService.requestFreeTrial(email, turingToken, turingType).then((param)=>{
            let { requestTrial  } = param;
            return handleSuccess(requestTrial, storageService);
        }).then(either/* Right */.O6).catch(either/* Left.from */.dv.from(expectedErrors));
    };
};

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/validation/index.js + 7 modules
var validation = __webpack_require__(69340);
;// CONCATENATED MODULE: ./src/FreeTrialForm/form.js

const initialState = {
    email: ""
};
const schema = {
    email: [
        [
            validation/* required */.C1,
            "errors.EMAIL_REQUIRED"
        ],
        [
            (0,validation/* isCorrectEmailLen */.jh)(64),
            "errors.EMAIL_INVALID_LENGTH"
        ],
        [
            validation/* isEmail */.Jh,
            "errors.WRONG_EMAIL"
        ]
    ]
};
const validateForm = (0,validation/* default */.ZP)(schema);

// EXTERNAL MODULE: ./src/utils/FlashErrorMessage.js
var FlashErrorMessage = __webpack_require__(77637);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(89032);
;// CONCATENATED MODULE: ./src/FreeTrialForm/index.js

















const FreeTrialForm = (param)=>{
    let { trialTokenExpired  } = param;
    const [t] = (0,i18/* useLocale */.bU)("free-trial");
    const [action, { isLoading , error , reset , type  }] = (0,anyCaptcha/* useFormActionWithAnyCaptcha */.Xr)(requestFreeTrial, {
        endOn: "then",
        googleRecaptchaSiteKey: config/* publicConfig.GOOGLE_RECAPTCHA_SITE_KEY */.mn.GOOGLE_RECAPTCHA_SITE_KEY,
        castlePublicKey: config/* publicConfig.CASTLE_PUBLIC_KEY */.mn.CASTLE_PUBLIC_KEY,
        action: "requestTrial"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Row */.X2, {
                utility: {
                    justify: "center"
                },
                children: [
                    isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {}),
                    trialTokenExpired && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlashErrorMessage/* default */.Z, {
                        text: t("errors.EXPIRED_TOKEN")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmartForm/* default */.ZP, {
                            textRender: t,
                            initialState: initialState,
                            validateForm: validateForm,
                            action,
                            onTouched: reset,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                                    sx: {
                                        textAlign: "left"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartForm/* default.Field */.ZP.Field, {
                                        label: "EMAIL",
                                        name: "email",
                                        type: "email",
                                        disabled: isLoading,
                                        error: error,
                                        fieldClassName: "mb-6",
                                        required: true,
                                        "data-qa-selector": "free-trial-email-input"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                        spacing: {
                                            mt: 2,
                                            mb: 6
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                                            sx: {
                                                textAlign: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                type: "submit",
                                                disabled: isLoading,
                                                isBlock: true,
                                                "data-qa-selector": "free-trial-submit-button",
                                                children: t("SUBMIT")
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "xs",
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                    Tag: "span",
                    children: t("AGREEMENT", {
                        tosLink: routes/* default.external.termsOfService */.Z.external.termsOfService,
                        ppLink: routes/* default.external.privacyPolicy */.Z.external.privacyPolicy
                    })
                })
            }),
            !!type && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* default */.Z, {
                sx: {
                    textAlign: "center"
                },
                children: [
                    type === "google-recaptcha" && /*#__PURE__*/ (0,jsx_runtime.jsx)(anyCaptcha/* GoogleRecaptchaNotice */.Wl, {}),
                    type === "castle" && /*#__PURE__*/ (0,jsx_runtime.jsx)(anyCaptcha/* CastleNotice */.FW, {})
                ]
            })
        ]
    });
};
FreeTrialForm.propTypes = {
    trialTokenExpired: prop_types.string
};
/* harmony default export */ var src_FreeTrialForm = (FreeTrialForm);

// EXTERNAL MODULE: ./src/services/index.js + 11 modules
var services = __webpack_require__(69549);
// EXTERNAL MODULE: ./src/AppError/withErrorHandling.js
var withErrorHandling = __webpack_require__(71802);
// EXTERNAL MODULE: ./src/SiteLayout/index.js
var SiteLayout = __webpack_require__(26485);
// EXTERNAL MODULE: ./src/Maintenance/WithMaintenance.js + 1 modules
var WithMaintenance = __webpack_require__(25890);
;// CONCATENATED MODULE: ./src/Apps/FreeTrial/index.js




















const iconPrime = "/images/geneious/logo/icon-prime.svg";
const iconBiologics = "/images/geneious/logo/icon-biologics.svg";
const FreeTrialPage = (param)=>{
    let { expired  } = param;
    const [t] = (0,i18/* useLocale */.bU)("free-trial");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        isWrapper: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                title: t("META.TITLE"),
                description: t("META.DESCRIPTION"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                        locale: t("META.LOCALE"),
                        type: t("META.TYPE"),
                        title: t("META.TITLE"),
                        description: t("META.DESCRIPTION"),
                        url: t("META.URL"),
                        siteName: t("META.SITE_NAME"),
                        articlePublisher: t("META.ARTICLE_PUBLISHER")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                        href: t("META.CANONICAL")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Twitter */.ZP.Twitter, {
                        card: t("META.TWITTER_CARD"),
                        title: t("META.TITLE"),
                        description: t("META.DESCRIPTION"),
                        site: t("META.TWITTER_SITE"),
                        creator: t("META.TWITTER_CREATOR")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
                utility: {
                    bgColor: "dotmatics-4"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                    utility: {
                        bgColor: "white"
                    },
                    spacing: {
                        pt: 9
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Row */.X2, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                        md: "auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsTab/* default */.Z, {
                                            logoIcon: iconPrime,
                                            borderColor: "3",
                                            title: t("TAB1.TITLE"),
                                            description: t("TAB1.DESCRIPTION"),
                                            active: true,
                                            "data-qa-selector": "geneious-prime-tab"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                        md: "auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsTab/* default */.Z, {
                                            logoIcon: iconBiologics,
                                            borderColor: "dotmatics-7",
                                            title: t("TAB2.TITLE"),
                                            description: t("TAB2.DESCRIPTION"),
                                            href: routes/* default.external.externalGetStartedBiologics */.Z.external.externalGetStartedBiologics,
                                            "data-qa-selector": "geneious-biologics-tab"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
                utility: {
                    bgColor: "dotmatics-4"
                },
                spacing: {
                    py: 20
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
                    md: 6,
                    center: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Panel/* default */.Z, {
                        spacing: {
                            py: 12,
                            px: 12
                        },
                        sx: {
                            textAlign: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                                Tag: "h2",
                                size: "l",
                                "data-qa-selector": "free-trial-main-heading",
                                children: [
                                    t("TITLE_FIRST_LINE"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " ",
                                    t("TITLE_SECOND_LINE")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                sx: {
                                    fontColor: "black--custom-1",
                                    fontSize: "l"
                                },
                                "data-qa-selector": "free-trial-description-paragraph",
                                children: t("SUB_TITLE")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(src_FreeTrialForm, {
                                trialTokenExpired: expired
                            }, Math.random())
                        ]
                    })
                })
            })
        ]
    });
};
const expired = (param)=>{
    let { query  } = param;
    return query.expired;
};
FreeTrialPage.propTypes = {
    expired: prop_types.string
};
FreeTrialPage.getInitialProps = (0,props_resolver/* default */.Z)({
    expired
});
/* harmony default export */ var FreeTrial = ((0,pipe/* default */.Z)(FreeTrialPage, withErrorHandling/* default */.Z, services/* default */.Z, (0,WithMaintenance/* default */.Z)({
    level: "NEW_ECOMM_AND_SIGNUPS"
})));

;// CONCATENATED MODULE: ./pages/free-trial/index.js



/***/ }),

/***/ 25890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Maintenance_WithMaintenance; }
});

// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/WithMaintenance/index.js + 1 modules
var WithMaintenance = __webpack_require__(77358);
// EXTERNAL MODULE: ./src/services/index.js + 11 modules
var services = __webpack_require__(69549);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./src/AppError/ErrorLayout.js
var ErrorLayout = __webpack_require__(59093);
;// CONCATENATED MODULE: ./src/Maintenance/Maintenance.jsx





const Maintenance = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "We’re undergoing maintenance."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: "We’re sorry. We’re temporarily unavailable. Please come back later."
            })
        ]
    });
/* harmony default export */ var Maintenance_Maintenance = (Maintenance);

;// CONCATENATED MODULE: ./src/Maintenance/WithMaintenance.js



/* harmony default export */ var Maintenance_WithMaintenance = ((0,WithMaintenance/* default */.Z)({
    MaintenanceComp: Maintenance_Maintenance,
    serviceCore: services/* serviceCore */.T
}));


/***/ }),

/***/ 7789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25522);
/* harmony import */ var _insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6949);
/* harmony import */ var _insightfulscience_atomic_react_Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42866);
/* harmony import */ var _insightfulscience_atomic_react_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10334);
/* harmony import */ var _insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74229);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _insightfulscience_atomic_react_props_sx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23720);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);









const ProductsTab = (param)=>{
    let { borderColor , logoIcon , title , description , active , ...props } = param;
    const { href  } = props;
    const border = {
        top: {
            color: active ? borderColor : "white",
            width: "4"
        }
    };
    const CustomLink = (param)=>/*#__PURE__*/ {
        let { ...customProps } = param;
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            ...customProps,
            isBaseClassName: false
        });
    };
    const Tag = href ? CustomLink : _insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        ...props,
        sx: {
            fontColor: "black"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            sx: {
                textAlign: "center"
            },
            utility: {
                bgColor: active ? "dotmatics-4" : "white",
                border
            },
            spacing: {
                pt: 4,
                pb: 5
            },
            ...props,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    Tag: "h3",
                    size: "l",
                    center: true,
                    children: [
                        title,
                        " ",
                        logoIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            src: logoIcon,
                            spacing: {
                                ml: 1
                            }
                        })
                    ]
                }),
                description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Paragraph__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    spacing: {
                        mb: 0
                    },
                    children: description
                })
            ]
        })
    });
};
ProductsTab.propTypes = {
    active: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    borderColor: _insightfulscience_atomic_react_props_sx__WEBPACK_IMPORTED_MODULE_6__/* .colorPropTypes */ .AK,
    logoIcon: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    title: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    href: prop_types__WEBPACK_IMPORTED_MODULE_8__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductsTab);


/***/ }),

/***/ 93890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports MetaTwitter, MetaOGP */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73445);





const Robots = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "robots",
            content: content
        })
    });
};
Robots.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Author = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "author",
            content: content
        })
    });
};
Author.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Canonical = (param)=>/*#__PURE__*/ {
    let { href  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "canonical",
            href: href
        })
    });
};
Canonical.propTypes = {
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
};
const CanonicalAlternate = (param)=>/*#__PURE__*/ {
    let { type ="text/html" , hrefLang , href , title =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "alternate",
            type: type,
            hrefLang: hrefLang,
            href: href,
            title: title
        })
    });
};
CanonicalAlternate.propTypes = {
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const MetaTwitter = (param)=>{
    let { card ="" , title ="" , description ="" , site ="" , image ="" , creator ="" , isImageBaseUrl =false  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            card && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: card
            }),
            site && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: site
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: "".concat(baseUrl).concat(image)
            }),
            creator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: creator
            })
        ]
    });
};
MetaTwitter.propTypes = {
    card: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    site: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    creator: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool
};
const MetaOGP = (param)=>{
    let { isImageBaseUrl =false , title ="" , description ="" , locale ="" , type ="" , url ="" , image ="" , imageSecureUrl ="" , siteName ="" , articlePublisher =""  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            locale && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: locale
            }),
            type && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: type
            }),
            url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "".concat(baseUrl).concat(image)
            }),
            imageSecureUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: "".concat(baseUrl).concat(imageSecureUrl)
            }),
            siteName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: siteName
            }),
            articlePublisher && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "article:publisher",
                content: articlePublisher
            })
        ]
    });
};
MetaOGP.propTypes = {
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    locale: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    url: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    imageSecureUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    siteName: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    articlePublisher: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const PageMeta = (param)=>{
    let { title ="" , description ="" , children =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    })
                ]
            }),
            children
        ]
    });
};
const CustomHead = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: children
    });
};
CustomHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
PageMeta.Robots = Robots;
PageMeta.Custom = CustomHead;
PageMeta.Canonical = Canonical;
PageMeta.CanonicalAlternate = CanonicalAlternate;
PageMeta.Author = Author;
PageMeta.Twitter = MetaTwitter;
PageMeta.OGP = MetaOGP;
PageMeta.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
/* harmony default export */ __webpack_exports__["ZP"] = (PageMeta);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7959,5040,3816,741,6436,9549,5659,9774,2888,179], function() { return __webpack_exec__(97239), __webpack_exec__(13932); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);